// i18n
import { i18n } from '@ecg-marktplaats/js-react-i18n';
import dateLocale from 'date-fns/locale/nl';
import translation from '../../../../locales/nl-BE/translation.json';
import common from '../../../../locales/nl-BE/common.json';
import priceTypes from '../../../../locales/nl-BE/priceTypes.json';
import p2pPaymentsUi from '@ecg-marktplaats/p2p-payments-ui/locales/nl-BE.json';
import reviewsDialogUi from '@ecg-marktplaats/reviews-dialog-ui/locales/nl-BE.json';

export default i18n.init({
  lng: 'nl-BE',
  dateLocale,
  translations: {
    translation,
    common,
    priceTypes,
    p2pPaymentsUi,
    reviewsDialogUi,
  },
});
